export const LANG = [
    { title: "한국어", code: "kor" },
    { title: "English", code: "eng" },
];
